import { render } from "./museumActivityCreate.vue?vue&type=template&id=0b6dd61e"
import script from "./museumActivityCreate.vue?vue&type=script&lang=js"
export * from "./museumActivityCreate.vue?vue&type=script&lang=js"

import "./museumActivityCreate.vue?vue&type=style&index=0&id=0b6dd61e&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__